import { Component, OnInit } from '@angular/core';
import { SaleService } from '../sale.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { ContractorService } from '../../contractors/contractor.service';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-sale',
  templateUrl: './sale.component.html',
  styleUrls: ['./sale.component.css'],
  providers: [SaleService, ContractorService]
})



export class SaleComponent implements OnInit {

  saleCart: any = [];
  sale: any;
  saleItems: any = [];
  _store_id: any;
  send_parametr: any;
  msgs: Message[] = [];
  contractors: any[] = [];
  contractor: any;

  soldDay: string;
  soldMonth: string;
  soldYear: string;

  isChangingModal:boolean = false;
  forIsChangingContractorId:string;
  forIsChangingSaleId:string;

  saleItemIdForRefund: string = "";
  saleItemId: any = "";
  saleItemPrice: any = 0;
  clinetButtonDisable: boolean = true;
  loading: boolean = false;
  loadingSale: boolean = false;
  loadingSaleItem: boolean = true;
  saleItemModal: boolean = false;
  saleRefundModal: boolean = false;

  applyFormDisplay: boolean = false;
  messageDisplay: boolean = false;
  deleteIndex: any;

  pagination: Pagination;

  selectClientDialogVisible: boolean = false;

  saleCartServer: any[] = [];
  saleCartServerLoading: boolean = false;

  public redactionDescription: string ="";

  searchFilter: any = [];
  searchColumn: any = [];
  statusList: any = [];
  contractorList: any = [];

  store: any;
  stores: any=[];
  storeDropdownDisable:boolean = false;

  counterForButtonDisable: number=0;

  constructor(
    private saleService: SaleService,
    public global: GlobalDataService,
    private contractorService: ContractorService,
    private router: Router) {

  }

  ngOnInit() {

    this.soldDay = this.global.soldDayCache;
    this.soldMonth = this.global.soldMonthCache;
    this.soldYear = this.global.soldYearCache;

    this.fillSearchColumn();
    this.init();

    this.pagination = {
      current_page: 1,
      per_page: 1,
      last_page: 1
    }
    this.onLoad();
    // this.sale={};
    // this.sale.status={};
    // this.sale.status.id=0;
    // this.loadSaleCartGrid();
    // this.loadSaleGrid();
    // this._store_id=this.global.user.stores[0].id;
    this.contractorService.getContractorList().subscribe(response => { 
      this.contractors = response['data'].map(function (value) { return { label: value.name, value: { id: value.id, name: value.name } } });
    //  this.contractors.splice(0, 1); 
    });
    this.loadSaleServerByFilter();
  }

  showRedactionDiscription(description: string){
    this.redactionDescription = description;
  }

  loadSaleServerByFilter(filter=[],page: number = 1) {
    this.saleCartServerLoading = true;
    this.saleService.getSaleByFilter(filter,page).subscribe(response => { this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1}; this.saleCartServer = response['data']; this.saleCartServerLoading = false; });
  }

  onPaginate(event) {
    event.page = event.page + 1
    this.pagination.current_page=event.page;
    this.loadSaleServerByFilter(this.searchFilter,event.page);
  }
  

  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Номер", value: { column: "invoice_number", type: "textbox" } });
    this.searchColumn.push({ label: "Статус", value: { column: "status_id", type: "dropdown" , value:  this.statusList} });
    this.searchColumn.push({ label: "Компания", value: { column: "contractor_id", type: "dropdown",value: this.contractorList } });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
    this.searchColumn.push({ label: "Дата начала", value: { column: "date_start", type: "calendar"} });
    this.searchColumn.push({ label: "Дата конца", value: { column: "date_finish", type: "calendar"} });
  }

  setFilter(data){
    this.searchFilter=data;
    this.loadSaleServerByFilter(this.searchFilter, 1);
  }
 
  init(){

    this.statusList.push({ label: 'Завершен', value: { value: 4, label: 'Завершен' }});
    this.statusList.push({ label: 'Принят', value: { value: 3, label: 'Принят' }});
    this.statusList.push({ label: 'На рассмотрении', value: { value: 2, label: 'На рассмотрении' }});
    this.fillSearchColumn();

    this.contractorService.getContractorList().subscribe(response => {
      this.contractorList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      this.fillSearchColumn();
    })

   

  }

  showSaleListItems(sale:any){
    this.router.navigate(['/dashboard/sale-list-items', sale.id]);
  }

  getSold(type:number){
    console.log(this.global.user.stores);
    this.saleService.getSoldStatistic({type:type,store_id:'e5767d48-f82c-4e52-a410-7711e0fabe6a'}).subscribe(response => { 
    
      if(response){

      if(type==1){
        this.soldDay = response['data']['weight'];
        this.global.soldDayCache=this.soldDay;
      }else if(type==2){
        this.soldMonth = response['data']['weight'];
        this.global.soldMonthCache=this.soldMonth;
      }else if(type==3){
        this.soldYear = response['data']['weight'];
        this.global.soldYearCache=this.soldYear;
      }
    }

    });
  }


  print() {
    this.saleService.printSale(this.saleItemId).subscribe(response => { window.open(response['data'].link); });
  }

  printReview(){
    this.saleService.printSaleReview(this.saleItemId).subscribe(response => { window.open(response['data'].link); });
  }

  getColor(statusId: any) {
    switch (+statusId) {
      case 0:
        return "#a5a4a4";
      case 2:
        return "orange";
      case 3:
        return "#2185d0";
      case 4:
        return "#26ea53";
      case 5:
          return "#AEADAD";
      case -1:
        return "#db2828";
    }
  }
  getSaleById(sale: any) {
    this.sale = sale;
    this.saleItemId = this.sale.id;
    this.saleItems = [];
    this.saleItemModal = true;
    this.loadingSaleItem = true;
    this.saleService.getSaleItemListByIdService(this.sale.id).subscribe(response => {
      this.saleItems = response['data'];
      this.loadingSaleItem = false;
    })
  }

  onLoad() {
    this.loading = true;
    if (localStorage.getItem('sales')) {
      this.saleCart = JSON.parse(localStorage.getItem('sales'));
      this.saleCart = this.saleCart.map((value, index) => { value.index = index; return value; });
      console.log(this.saleCart);
    }
    this.loading = false;
  }

  onUpdateIssueSale(id: any, contractorId: any,isChangingRow:number) {
    this.forIsChangingContractorId = contractorId;
    this.forIsChangingSaleId = id;
    if(isChangingRow==0){
      this.saleService.saleChanging(id,true).subscribe();    
      this.router.navigate(['/dashboard/sale-update/', { contractor_id: contractorId, from_type: "sale", id: id }]);
    }else{
      this.isChangingModal = true;
    }
  }

  OnAgreeChange(){
    this.router.navigate(['/dashboard/sale-update/', { contractor_id: this.forIsChangingContractorId, from_type: "sale", id: this.forIsChangingSaleId }]);
  }

  delete(index: any): void {
    this.messageDisplay = true;
    this.deleteIndex = index;
  }

  OnAgreeDelete() {
    this.saleCart.splice(this.deleteIndex, 1);
    this.deleteIndex = null;
    this.messageDisplay = false;
    this.save();
    this.onLoad();
  }

  OnDegreeDelete() {
    this.messageDisplay = false;
  }

  open(index: any): void {
    this.router.navigate(['/dashboard/sale-items/', index]);
  }

  save() {
    localStorage.setItem('sales', JSON.stringify(this.saleCart));
  }

  add(): void {
    this.selectClientDialogVisible = true;

    this.storeDropdownDisable=false;
    
    this.stores =this.global.user.stores.map(function(value){return {label: value.name, value: {id: value.id, name: value.name}}});

    if(this.stores.length==1){
      this.counterForButtonDisable+=1;
      this.storeDropdownDisable=true;
      this.store = this.stores[0].value;
    }

  }

  onChange(event) {

    this.counterForButtonDisable+=1;  
    if(this.counterForButtonDisable==2){
      this.clinetButtonDisable = false;
    }
    this.contractor = event.value;
    console.log(this.contractor);
  }

  onSelectedStore(event){
    
    this.counterForButtonDisable+=1; 
    if(this.counterForButtonDisable==2){
      this.clinetButtonDisable = false;
    }
  }

  onNext() {
    console.log(this.store);
    this.saleCart.push({
      index: this.saleCart.length,
      invoice_number: (+this.saleCart.length > 0 ? this.saleCart[this.saleCart.length - 1].invoice_number + 1 : 1),
      contractor: this.contractor,
      created_at: new Date().toISOString().slice(0, 10),
      created_by: { id: this.global['user']['id'], full_name: this.global['user']['contact']['full_name'] },
      status: { name: "Новая" },
      store_id: this.store.id,
      items: [],
      paid: 0
    });
    this.save();
    this.router.navigate(['/dashboard/sale-items/', this.saleCart.length - 1]);

  }

  onApplyAcceptedSale() {
    this.applyFormDisplay = false;
    this.saleItemModal = false;
    this.saleService.applyAcceptedSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleServerByFilter(this.searchFilter,this.pagination.current_page);
    });
  }

  onApplyFinishSale() {
    this.applyFormDisplay = false;
    this.saleItemModal = false;
    this.saleService.applyFinishSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleServerByFilter(this.searchFilter,this.pagination.current_page);
    });
  }

  onApplyInprocessingSale() {
    this.applyFormDisplay = false;
    this.saleItemModal = false;
    this.saleService.applyInprocessingSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleServerByFilter(this.searchFilter,this.pagination.current_page);
    });
  }

  /**
   * 
   * @param type 1 = accountant; 2 = storemen 
   */
  onShowApplyDisplay(type: number) {
    switch (type) {
      case 1:

        break;
      case 2:

        break;
    }

    this.applyFormDisplay = true;
  }

  showRefundModal(id: any, price: any) {
    this.saleItemPrice = price;
    this.saleRefundModal = true;
    this.saleItemIdForRefund = id;
  }

  refundProduct(form: NgForm) {
    this.saleService.refundProductService(form.value).subscribe(response => { this.saleRefundModal = false; this.getSaleById(this.saleItemId); });
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale/sale.component.ts